import React from 'react'
import { NextPage } from 'next'
import StorefrontCategory from '@local-types/categories/storefrontCategory'
import CategoryPage from 'components/categories/categoryPage'
import { createClient } from 'prismicConfiguration'
import ProductCategoryPage from 'interfaces/prismic/productCategory'
import categories from 'apiService/categories'
// @ts-ignore
import { RichText } from 'prismic-reactjs'
import { isUuid } from 'utils/prismic'

interface Props {
	category: StorefrontCategory | null
	categoryPage: ProductCategoryPage | null
}

const ProductCategory: NextPage<Props> = ({ category, categoryPage }) => {
	return <CategoryPage category={category} categoryPage={categoryPage} />
}

ProductCategory.getInitialProps = async context => {
	const { query } = context
	const slug = query?.cslug?.toString() || ''
	const res = await categories.get(isUuid(slug) ? { ids: [slug] } : { slugs: [slug] })
	const cat = res.data[0] || null
	const client = createClient()
	const page = cat ? await client.getByUID<ProductCategoryPage>('product_category', cat.id, {}) : null
	const label = page?.data?.title ? RichText.asText(page.data.title) : cat?.name ? cat.name : ''
	return { category: cat, categoryPage: page || null, label }
}

export default ProductCategory
